export function isDevEnvironment() {
    const env = false;
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
        return true;
    }
    return env;
}
